import React, { useEffect, useState } from 'react';
import styles from './ForWhomMain.module.css';
import { CustomButton, CustomFooter, CustomImage, CustomLoader, CustomMoreSection, CustomScrollIndicator, CustomTextMarkdown } from '../../../components';
import { getForWhomContent } from '../../../services/contentService';
import { ReactComponent as ArrowRightBlue } from '../../../assets/icons/arrow_right_blue.svg';
import { useTranslation } from 'react-i18next';
import colors from '../../../styles/colors';
import { useNavigate } from 'react-router-dom';

const ForWhom = () => {

    const {t} = useTranslation();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [pageContent, setPageContent] = useState<any>(null);

    useEffect(() => {
        handleGetForWhomContent();
    }, []);

    const handleGetForWhomContent = async () => {
        try {
            setIsLoading(true);

            const content = await getForWhomContent();
            setPageContent(content);

            const homeImg = new Image();
            homeImg.onload = () => setIsLoading(false);
            homeImg.src = `${process.env.REACT_APP_API_BASE_URL}${content.A_block_image.url}`;
        } catch(e) {
            console.error(e);
            throw e;
        }
    }

    return (
        <div className={styles.container}>
            
            { !isLoading &&
                <>
                    
                    {/* A block */}
                    <div className={styles.A_block}>
                        <div className={styles.A_block_container_title}>
                            <div className={styles.left_spacer}></div>

                            <div className={styles.A_block_center_title}>
                                <CustomTextMarkdown className={`${styles.A_block_subtitle} ${styles.subtitle}`}>{pageContent.A_block_subtitle}</CustomTextMarkdown>
                                <CustomTextMarkdown components={{ p : 'h1' }} className={styles.A_block_title}>{pageContent.A_block_title}</CustomTextMarkdown>
                            </div>
                            
                            <div className={styles.A_block_scroll_ind_container}>
                                <CustomScrollIndicator />
                            </div>
                        </div>

                        <div className={styles.A_block_img_container}>
                            <CustomImage src={`${process.env.REACT_APP_API_BASE_URL}${pageContent.A_block_image?.url}`} alt="" />
                        </div>

                        <CustomTextMarkdown className={styles.A_block_paragraph}>{pageContent.A_block_paragraph}</CustomTextMarkdown>
                    </div>


                    {/* B block */}
                    <div className={styles.B_block}>
                        { pageContent.sections.map((item: any, index: number) => {

                            const card = item.Section_presentation_card;

                            return (
                                <div key={index} role='button' tabIndex={0} className={styles.card} onClick={() => navigate('/for_whom/' + index)}>
                                    <div className={styles.card_title_container}>
                                        <div className={styles.card_icon_container}>
                                            <CustomImage src={`${process.env.REACT_APP_API_BASE_URL}${card.icon?.url}`} alt="" />
                                        </div>

                                        <div>
                                            <CustomTextMarkdown components={{ p : 'h4' }} className={styles.card_title}>{card.title}</CustomTextMarkdown>
                                            <CustomTextMarkdown components={{ p : 'h6' }} className={styles.card_subtitle}>{card.subtitle}</CustomTextMarkdown>
                                        </div>
                                    </div>

                                    <div className={styles.card_image_container}>
                                        <CustomImage src={`${process.env.REACT_APP_API_BASE_URL}${card.image?.url}`} alt="" />
                                    </div>

                                    <div className={styles.card_content}>
                                        <CustomTextMarkdown>{card.content}</CustomTextMarkdown>
                                    </div>

                                    <CustomButton
                                        buttonType="outlined"
                                        color={colors.blue}
                                        endIcon={<ArrowRightBlue />}
                                    >
                                        {t('general.learn_more')}
                                    </CustomButton>
                                </div>
                            );
                        })}
                    </div>

                    <CustomMoreSection />
                    <CustomFooter />
                </>
            }

            { isLoading &&
                <div className={styles.container_loader}>
                    <CustomLoader loaderType="skeleton" isLoading={isLoading}/>
                </div>
            }

        </div>
    );
}

export default ForWhom;